import React from 'react'
import biote888 from '../../../images/biote888.png'

import biote_fin from '../../../images/biote_fin.png'
import Third_pane from '../../ValleyCourt2/Blocks/Third_pane'


const First_pane = () => {
  return (
   <div className=''>
           <div
        
        style={{ 
        backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${biote888})`,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${biote888})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingBottom: '50px',
        paddingTop: '100px',
        height: '100vh'
        }}
    
    
    >


        <div className='uk-container'>

            <div className='uk-grid' data-uk-grid>
                <div className='uk-width-1-2@s'>
                    
           <h1 className='light header1 uk-margin-xlarge-top' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Biote 888 Residence</h1>
      
           <h5 className='light uk-margin-medium-top'
            uk-scrollspy="cls: uk-animation-fade; repeat: true">
              
Plot Number: 888, Cad Zone C02,Gwarinpa 1 District              
Plot Title:    Certificate of Occupancy <br/>
Plot Size:    1,490.49M <br/>
Land Use:    Residential<br/>
Mode of Land Acquisition:     Joint Venture<br/>
Total No. Of Housing Units:    6 Units<br/>
Project Start Date:    December 2022<br/>

              
              </h5>
                </div>

                <div className='uk-width-1-2@s'>

                </div>
            </div>

    




        </div>
       
    </div>


  <div className='uk-container uk-margin-large-top' >
         <h3>The Promise</h3>
        <div className='uk-width-1-1'>
            <img src={biote888} />
        </div>
      </div>

  <div className='uk-container uk-margin-large-top' >
         <h3>The Completed Project</h3>
        <div className='uk-width-1-1'>
            <img src={biote_fin} />
        </div>
      </div>
      

     <Third_pane />




    </div>
  )
}

export default First_pane